// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__36Qe_","col":"styles_col__3a0dN"};